module.exports = __webpack_public_path__ + "static/media/4.03895aca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/4.svg
// module id = 131
// module chunks = 0